import React, { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from 'lodash';

const useSearchNode = (reactFlowInstance) => {
  const [results, setResults] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selected = useRef({ index: 0, total: 0, opened: false, results: [] });

  const handleSearch = useCallback(debounce((searchContent) => {
    const results = [];
    let nodes = reactFlowInstance?.getNodes() ?? [];
    const contentLowerCase = searchContent.toLowerCase()
    nodes = nodes.filter(n => n?.data?.label);
    if (searchContent) {
      for (const node of nodes) {
        if (node?.data) {
          const isMatchComment = node?.data?.comment?.toLowerCase()?.includes(contentLowerCase);
          const isMatchLabel = node?.data?.label?.toLowerCase().includes(contentLowerCase);
          let isMatchData = false;
          for (const option in node?.data?.options) {
            if (node?.data?.options[option]?.toString()?.toLowerCase().includes(contentLowerCase)) {
              isMatchData = true;
            }
          }
          if (isMatchLabel || isMatchData || isMatchComment) {
            results.push(node);
          }
        }
      }
      selected.current.total = results.length;
      selected.current.results = results;
    } else {
      selected.current.results = nodes;
      selected.current.total = nodes.length ?? 0;
    }
    selected.current.index = 0;
    setSelectedIndex(0);
    setResults(selected.current.results);
  }, 350), [reactFlowInstance]);

  const onSelectNode = (node) => {
    let x = node.position.x;
    let y = node.position.y;
    if (node.extent === 'parent' && node.parentNode) {
      const nodes = reactFlowInstance?.getNodes() ?? [];
      const parentNode = nodes.find(n => n.id === node.parentNode);
      if (parentNode) {
        x += parentNode.position.x;
        y += parentNode.position.y;
      }
    }
    const zoom = 1.15;
    const targetX = x * -zoom + window.innerWidth / 2 - (node.width || 0) / 2;
    const targetY = y * -zoom + window.innerHeight / 2 - (node.height || 0) / 2;
    reactFlowInstance.setViewport({x: targetX, y: targetY, zoom}, { duration: 350 });
    blinkNodeById(node.id);
  };

  const blinkNodeById = (id) => {
    reactFlowInstance.setNodes((nds) =>
      nds.map((n) =>
        n.id === id ? { ...n, className: "blink-node" } : n
      )
    );
    setTimeout(() => {
      reactFlowInstance.setNodes((nds) =>
        nds.map((n) =>
          n.id === id ? { ...n, className: "" } : n
        )
      );
    }, 1500);
  };

  const handleKeyDown = (e) => {
    if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
      e.stopPropagation();
      let selectedIndex = selected.current.index;
      let totalResult = selected.current.total;
      switch (e.key) {
        case 'ArrowDown':
          selected.current.index = selectedIndex+1 >= totalResult ? 0 : selectedIndex+1;
          break;
        case 'ArrowUp':
          selected.current.index = selectedIndex-1 < 0 ? totalResult-1 : selectedIndex-1;
          break;
      }
      setSelectedIndex(selected.current.index);
    }
  }

  return {
    onSelectNode,
    selectedIndex,
    selected,
    results,
    handleSearch,
    handleKeyDown,
  }
}

export default useSearchNode;
